<template>
  <section class="p-2">
    <v-card class="pa-2">
      <loading
        :active="isload"
        :is-full-page="false"
        :opacity="0.7"
        color="#ff6b00"
      />
      <h6>Personal Details</h6>
      <v-divider></v-divider>
      <v-form ref="complincmanual" v-model="valid" lazy-validation>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> First Name </label>
            <v-text-field
              class="rounded"
              :rules="first_nameRules"
              v-model="customerINDdata.first_name"
              dense
              outlined
              placeholder="First Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize my-0"> Middle Name </label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="customerINDdata.middle_name"
              placeholder="Middle Name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Last Name </label>
            <v-text-field
              class="rounded"
              :rules="last_nameRules"
              v-model="customerINDdata.last_name"
              dense
              outlined
              placeholder="Last Name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Date Of Birth </label>
            <v-text-field
              class="rounded"
              :max="maxDate"
              :rules="[DOBRules]"
              dense
              v-model="customerINDdata.dob"
              outlined
              type="date"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0">Nationality</label>
            <v-autocomplete
              class="rounded"
              v-model="customerINDdata.nationality_code"
              :items="dropdown.nationalityList"
              :rules="nationalityRules"
              dense
              outlined
              placeholder="Nationality"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Gender </label>
            <v-autocomplete
              class="rounded"
              dense
              v-model="customerINDdata.gender"
              :items="genderOptins"
              :rules="genderRules"
              outlined
              placeholder="Gender"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0">
              Country Of Birth
            </label>
            <v-autocomplete
              class="rounded"
              dense
              :items="dropdown.countryOptions"
              v-model="customerINDdata.country_of_birth"
              outlined
              :rules="CountryofbirthRules"
              placeholder="Country Of Birth"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize my-0"> Email Id </label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="customerINDdata.email_id"
              placeholder="Email Id"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Address </label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="customerINDdata.address"
              :rules="addressRule"
              placeholder="Address"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Country </label>
            <v-autocomplete
              class="rounded"
              :items="dropdown.countryOptions"
              v-model="customerINDdata.country_code"
              dense
              outlined
              @change="getStates()"
              :rules="CountryRules"
              placeholder="Country"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> State </label>
            <v-autocomplete
              class="rounded"
              dense
              outlined
              @change="getCities(true)"
              v-model="customerINDdata.state_code"
              :items="dropdown.state_options"
              :rules="StateRules"
              placeholder="State"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0">City</label>
            <v-autocomplete
              v-if="!cityInputEnabled"
              class="rounded"
              dense
              v-model="customerINDdata.city_code"
              :items="dropdown.city_options"
              :rules="CityRules"
              outlined
              placeholder="City"
            ></v-autocomplete>
            <v-text-field
              v-else
              class="rounded"
              dense
              v-model="customerINDdata.city_code"
              :rules="CityRules"
              outlined
              placeholder="Enter City"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="ms-1 me-1 mt-1" justify="center">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Postal Code </label>
            <v-autocomplete
              class="rounded"
              dense
              v-model="customerINDdata.zip_code"
              :items="dropdown.zipcodes"
              outlined
              :rules="pincodeRule"
              placeholder="Postal Code"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize required my-0">Contact Number </label>
            <v-text-field
              class="rounded"
              placeholder="Enter Contact Number"
              dense
              outlined
              v-model="customerINDdata.mobile_number"
              :rules="contactNumbrules"
              prefix="+60"
              required
              type="number"
              @wheel="(e) => e.target.blur()"
              hide-spin-buttons
              :hint="'+60 xx xxx xxxx'"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Occupation </label>
            <v-autocomplete
              class="rounded"
              dense
              outlined
              v-model="customerINDdata.occupation_code"
              :items="dropdown.occupation_list"
              :rules="occupationRules"
              placeholder="Occupation"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="start">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Employer</label>
            <v-text-field
              class="rounded"
              dense
              outlined
              v-model="customerINDdata.employer_name"
              :rules="employerRules"
              placeholder="Employer"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> Source Of Funds </label>
            <v-autocomplete
              class="rounded"
              dense
              v-model="customerINDdata.source_of_fund_code"
              :items="dropdown.sourceofFunds_list"
              outlined
              :rules="sourceofFundRules"
              placeholder="Source Of Funds"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <h6>KYC Details</h6>
        <v-divider></v-divider>

        <v-row class="ms-1 me-1 mt-1" justify="start">
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> ID Type </label>
            <v-select
              class="rounded"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="customerINDdata.id_type_code"
              :rules="validations.id_proofrules"
              :items="dropdown.ID_types"
              outlined
              required
              :placeholder="$t('idtype_select_placeholder')"
              dense
            ></v-select>
          </v-col>

          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> ID Number </label>
            <v-text-field
              class="rounded"
              :placeholder="$t('id_number_placeholder')"
              v-model="customerINDdata.id_number"
              :rules="validations.id_numberRules"
              outlined
              required
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label
              :class="
                customerINDdata.id_type_code === '4'
                  ? 'required labelFontsize my-0'
                  : 'labelFontsize my-0'
              "
            >
              Issue Location
            </label>
            <v-autocomplete
              class="rounded"
              v-model="customerINDdata.id_issue_country_code"
              :items="dropdown.countryOptions"
              :disabled="
                customerINDdata.id_type_code === '1' ||
                customerINDdata.id_type_code === '2'
              "
              :rules="
                customerINDdata.id_type_code === '4'
                  ? validations.issue_locationRules
                  : []
              "
              :placeholder="$t('Location')"
              dense
              outlined
              required
            />
          </v-col>
        </v-row>
        <v-row class="ms-1 me-1 mt-1" justify="start">
          <v-col
            cols="12"
            md="4"
            lg="4"
            xs="12"
            v-if="
              !isMykad &&
              !NOdatesIdtype.includes(customerINDdata.id_type_code)
            "
          >
            <label class="required labelFontsize my-0"> Issue Date </label>
            <v-text-field
              class="rounded"
              v-model="customerINDdata.id_issue_date"
              :rules="validations.issuedaterules"
              dense
              required
              outlined
              type="date"
            />
          </v-col>
          <v-col
            cols="12"
            md="4"
            lg="4"
            xs="12"
            v-if="
              !isMykad &&
              !NOdatesIdtype.includes(customerINDdata.id_type_code)
            "
          >
            <label class="required labelFontsize my-0"> Expiry Date </label>
            <v-text-field
              class="rounded"
              v-model="customerINDdata.id_expire_date"
              :rules="validations.expDateRules"
              dense
              outlined
              required
              type="date"
            />
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize my-0"> ID front Page</label>

            <v-file-input
              class="rounded"
              v-model="imageData.frontPage"
              dense
              accept="image/png, image/jpeg, image/bmp, image/bmp"
              :placeholder="$t('idtype_first_page_placeholder')"
              :rules="validations.firstpage_rules"
              outlined
              ref="idfirstfile"
              required
              prepend-icon=""
              @change="
                genrateURL('frontPageUrl', imageData.frontPage, 'frontPage')
              "
            >
              <template v-slot:append>
                <v-icon
                  aria-hidden="false"
                  class="color-primary"
                  @click="openIdfirst"
                >
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="imageData.frontPageUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="imageData.frontPageUrl"
                  @click="handleImageViewer(imageData.frontPageUrl)"
                />
              </template>
            </v-file-input>
          </v-col>

          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="labelFontsize ma-0 pa-0">ID Last Page</label>
            <v-file-input
              class="rounded"
              v-model="imageData.backpage"
              dense
              accept="image/png, image/jpeg, image/bmp, image/bmp"
              :placeholder="$t('idtype_last_page_placeholder')"
              outlined
              ref="idlastfile"
              required
              prepend-icon=""
              @change="
                genrateURL('backpageUrl', imageData.backpage, 'backpage')
              "
            >
              <template v-slot:append>
                <v-icon
                  aria-hidden="false"
                  @click="openIdlast"
                  class="color-primary"
                >
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="imageData.backpageUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="imageData.backpageUrl"
                  @click="handleImageViewer(imageData.backpageUrl)"
                />
              </template>
            </v-file-input>
          </v-col>
          <v-col cols="12" md="4" lg="4" xs="12">
            <label class="required labelFontsize ma-0 pa-0">{{
              $t("Selfy")
            }}</label>
            <v-file-input
              class="rounded"
              v-model="imageData.profile_pic"
              dense
              accept="image/png, image/jpeg, image/bmp, image/bmp"
              :placeholder="$t('idtype_selfy_page_placeholder')"
              :rules="validations.selfy_rules"
              outlined
              ref="selfiefile"
              required
              prepend-icon=""
              @change="
                genrateURL(
                  'profile_picUrl',
                  imageData.profile_pic,
                  'profile_pic',
                )
              "
            >
              <template v-slot:append>
                <v-icon aria-hidden="false" class="color-primary" @click="open">
                  mdi-cloud-upload
                </v-icon>
              </template>

              <template v-slot:append-outer>
                <v-img
                  v-if="imageData.profile_picUrl"
                  class="ml-1"
                  max-height="40"
                  max-width="50"
                  :src="imageData.profile_picUrl"
                  @click="handleImageViewer(imageData.profile_picUrl)"
                />
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-col cols="12" md="12">
          <v-row class="d-flex justify-end my-3">
            <v-btn
              v-if="update_cust_id || $route.query.customer_id"
              depressed
              small
              class="me-4 text-capitalize"
              color="error"
              @click="$emit('CloseDialog')"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
            </v-btn>
            <v-btn
              v-else
              depressed
              small
              class="me-4 text-capitalize"
              color="error"
              @click="cancel()"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel
            </v-btn>
            <v-btn
              v-if="update_cust_id || $route.query.customer_id"
              depressed
              color="primary"
              small
              @click="updateCustData()"
              class="me-2 text-capitalize rounded"
            >
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon
              >Update
            </v-btn>
            <v-btn
              v-else
              depressed
              color="primary"
              small
              @click="saveData()"
              class="me-2 text-capitalize rounded"
            >
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon
              >Submit
            </v-btn>
          </v-row>
        </v-col>
      </v-form>
    </v-card>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </section>
</template>
<script>
import alerts from "@/mixins/alerts";
import imageViewer from "@/components/tools/imageViewer.vue";
import Loading from "vue-loading-overlay";
import { i18n as $ } from "../../../locale/index";
import { findDatePrevious } from "@/utils/helper";
import { validation } from "@/utils/validationCopy.js";
import { checkNumber, mapMobilenumb } from "@/utils/contactNumber/formatNumber";
import userService from "@/services/UserService/userService.js";
import handleImageUpload from "../../../mixins/compressImage.mixin";
import commonService from "@/services/CommonService/commonService.js";
export default {
  mixins: [alerts, handleImageUpload],
  name: "Customer Individual",
  data: () => ({
    ...validation,
    checkNumber,
    mapMobilenumb,
    isImageViewer: false,
    imageViewerUrl: "",
    NOdatesIdtype: ["1", "2", "9", "12", "13", "7", "11"],
    cityInputEnabled: false,
    isload: false,
    valid: true,
    maxDate: "",
    show_overlay: false,
    genderOptins: ["Male", "Female"],
    minDate: new Date().toISOString().split("T")[0],
    customerINDdata: {
      first_name: null,
      middle_name: null,
      last_name: null,
      email_id: null,
      phone_number: "",
      dob: null,
      gender: "",
      employer_name: "",
      address: "",
      country_code: "MYS",
      nationality_code: "MYS",
      state_code: "",
      city_code: "",
      zip_code: "",
      occupation_code: "",
      source_of_fund_code: "",
      id_issue_country_code: "",
      id_type_code: "",
      id_number: "",
      id_expire_date: null,
      id_issue_date: null,
      id_issue_place: "",
      interview_date: null,
      interview_city: "",
      country_of_birth: "",
      partner_id: "",
      user_type: "IND",
      frontPage: null,
      backpage: null,
      profile_pic: null,
      mobile_number: "",
    },
    imageData: {
      frontPage: null,
      frontPageUrl: null,
      backpage: null,
      backpageUrl: null,
      profile_pic: null,
      profile_picUrl: null,
    },
    validations: {
      selfy_rules: [(v) => !!v || $.t("file_select_placeholder")],
      firstpage_rules: [(v) => !!v || $.t("file_select_placeholder")],
      issuedaterules: [(v) => !!v || $.t("issueDateMsg1")],
      issue_locationRules: [(v) => !!v || $.t("issue_location_placeholder")],
      expDateRules: [(v) => !!v || $.t("expiryDateMsg1")],
      id_proofrules: [(v) => !!v || $.t("idtypeMsg1")],
      id_numberRules: [(v) => !!v || $.t("idnumberMsg1")],
      interviewData: [(v) => !!v || $.t("interviewDate")],
      interviewTime: [(v) => !!v || $.t("interviewTime")],
    },
    dropdown: {
      nationalityList: [],
      countryOptions: [],
      state_options: [],
      city_options: [],
      occupation_list: [],
      zipcodes: [],
      sourceofFunds_list: [],
      ID_types: [],
    },
  }),
  created() {
    if (this.update_cust_id) {
      this.getprofiledata(this.update_cust_id);
    }
  },
  mounted() {
    this.customerINDdata.partner_id = sessionStorage.getItem("partner_id");
    if (this.$route.query.customer_id) {
      this.getprofiledata(this.$route.query.customer_id);
    }

    this.getcountryList();
    this.getOccupation();
    this.getzipcodes();

    this.getSourceOfFunds();
    this.getparameterdropdowns("DOC");
    this.maxDate = findDatePrevious(new Date(), 18);
  },
  components: {
    Loading,
    imageViewer,
  },
  computed: {
    isMykad() {
      return this.isMykadDocumentType(this.customerINDdata.id_type_code);
    },
  },
  props: {
    update_cust_id: {
      type: String,
    },
    cust_login_id: {
      type: String,
    },
  },
  watch: {
    "customerINDdata.id_type_code"(val) {
      if (val == "1" || val == "2") {
        this.customerINDdata.id_issue_country_code = "MYS";
      }
      if (this.isMykadDocumentType(val)) {
        this.customerINDdata.id_issue_date = null;
        this.customerINDdata.id_expire_date = null;
      }
    },
  },
  methods: {
    isMykadDocumentType(value) {
      const selectedType = this.dropdown.ID_types.find(
        (item) => String(item.value) === String(value),
      );
      const documentType = selectedType ? selectedType.text : value;
      const normalizedType = String(documentType || "")
        .replace(/[\s_-]/g, "")
        .toUpperCase();
      return normalizedType === "MYKAD";
    },
    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    openIdlast() {
      this.$refs.idlastfile.$el.querySelector("input").click();
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    cancel() {
      this.$refs.complincmanual.reset();
    },
    DOBRules(value) {
      if (!value) {
        return "Date of Birth is required";
      }
      if (value && !(value <= this.maxDate)) {
        return "Age should above 18";
      }
      return true; // Validation passed
    },
    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    genrateURL(keyField, value, assignKey) {
      if (!keyField) return;
      if (!value) {
        this.imageData[`${keyField}`] = null;
        this.customerINDdata[`${assignKey}`] = null;
      } else {
        this.imageData[`${keyField}`] = URL.createObjectURL(value);
        this.customerINDdata[`${assignKey}`] = value;
      }
    },
    async getprofiledata(id) {
      this.isload = true;
      const params = {
        customer_id: id,
      };
      try {
        const responseData = await userService.getRemittenceId(params);
        if (responseData.data.status_code === 200) {
          if (responseData.data.data && responseData.data.data.length > 0) {
            setTimeout(() => {
              const profileData = responseData.data.data[0];
              console.log(" profileData", profileData);
              this.customerINDdata = profileData;
              this.customerINDdata.city_code =
                profileData?.city && profileData?.city?.id;
              this.customerINDdata.country_code =
                profileData?.country && profileData?.country?.iso_alpha3;
              this.customerINDdata.state_code =
                profileData?.state && profileData?.state?.state_code;
              this.customerINDdata.country_of_birth =
                profileData?.country_of_birth &&
                profileData?.country_of_birth?.iso_alpha3;
              this.customerINDdata.nationality_code =
                profileData?.nationality_code &&
                profileData?.nationality_code?.iso_alpha3;
              this.customerINDdata.occupation_code =
                profileData?.occupation_code &&
                profileData?.occupation_code?.value_code;
              this.customerINDdata.source_of_fund_code =
                profileData?.source_of_fund_code &&
                profileData?.source_of_fund_code?.value_code;
              this.customerINDdata.mobile_number = profileData?.mobile_number
                ? this.mapMobilenumb(profileData?.mobile_number)
                : null;
              this.imageData.frontPage = profileData?.front_page
                ? {
                    name: profileData?.front_page_name || "",
                    value: profileData?.front_page,
                  }
                : null;
              console.log(
                "this.imageData.frontPage ",
                this.imageData.frontPage,
              );
              this.imageData.backpage = profileData?.back_page
                ? {
                    name: profileData?.back_page_name || "",
                    value: profileData?.back_page,
                  }
                : null;

              this.imageData.profile_pic = profileData?.selfie
                ? {
                    name: profileData?.selfie_name || "",
                    value: profileData?.selfie,
                  }
                : null;
              this.imageData.frontPageUrl = profileData?.front_page
                ? profileData?.front_page
                : null;
              console.log(
                "  this.imageData.frontPageUrl",
                this.imageData.frontPageUrl,
              );
              this.imageData.backpageUrl = profileData?.back_page
                ? profileData?.back_page
                : null;
              this.imageData.profile_picUrl = profileData?.selfie
                ? profileData?.selfie
                : null;
              console.log(
                " this.imageData.profile_picUrl ",
                this.imageData.profile_picUrl,
              );
              this.isload = false;
              this.getStates();
              this.getCities();
            }, 100);
          }
        } else {
          this.isload = false;
        }
        console.log("remiteeProfile: ", responseData);
      } catch (e) {
        this.isload = false;
        console.error(e);
      }
    },
    async updateCustData() {
      const cust_login_id = this.update_cust_id
        ? this.update_cust_id
        : this.$route.query.customer_id;
      const validate = this.$refs.complincmanual.validate();
      const Num_format = this.customerINDdata.mobile_number
        ? this.checkNumber(this.customerINDdata.mobile_number)
        : "";
      this.customerINDdata.phone_number = Num_format;
      this.customerINDdata.user_type = "IND";
      if (validate) {
        this.isload = true;
        try {
          const responseData = await userService.updateCustData(
            this.customerINDdata,
            cust_login_id,
          );
          if (responseData && responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            if (this.customerINDdata.frontPage) {
              this.uploadCustDocs(
                responseData.data.data[0].customer_id,
                "FRONT_PAGE",
                this.customerINDdata.frontPage,
              );
            }
            if (this.customerINDdata.backpage) {
              this.uploadCustDocs(
                responseData.data.data[0].customer_id,
                "BACK_PAGE",
                this.customerINDdata.backpage,
              );
            }
            if (this.customerINDdata.profile_pic) {
              this.uploadCustDocs(
                responseData.data.data[0].customer_id,
                "FACE_IMAGE",
                this.customerINDdata.profile_pic,
              );
            }
            if (this.$route.query.customer_id && this.$route.query.login_id) {
              this.$router.push({
                name: "Add Customer",
                params: {
                  user_type: "IND",
                  customer_id: this.$route.query.customer_id,
                },
              });
            }
            if (cust_login_id) {
              this.$emit("CloseDialog");
            }
            this.isload = false;
            this.$refs.complincmanual.reset();
          } else {
            this.isload = false;
            this.showAlertError(responseData.data.message);
          }
        } catch (error) {
          this.isload = false;
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async saveData() {
      const validate = this.$refs.complincmanual.validate();
      const Num_format = this.customerINDdata.mobile_number
        ? this.checkNumber(this.customerINDdata.mobile_number)
        : null;
      this.customerINDdata.phone_number = Num_format;
      if (validate) {
        console.log(`customerINDdata: ${JSON.stringify(this.customerINDdata)}`);
        this.isload = true;
        try {
          const responseData = await userService.addIndCustomer(
            this.customerINDdata,
          );
          if (responseData && responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            if (this.customerINDdata.frontPage) {
              this.uploadCustDocs(
                responseData.data.data[0].customer_id,
                "FRONT_PAGE",
                this.customerINDdata.frontPage,
              );
            }
            if (this.customerINDdata.backpage) {
              this.uploadCustDocs(
                responseData.data.data[0].customer_id,
                "BACK_PAGE",
                this.customerINDdata.backpage,
              );
            }
            if (this.customerINDdata.profile_pic) {
              this.uploadCustDocs(
                responseData.data.data[0].customer_id,
                "FACE_IMAGE",
                this.customerINDdata.profile_pic,
              );
            }
            this.$router.push({
              name: "Add Customer",
              params: {
                user_type: "IND",
                phone_number: responseData.data.data[0].phone_number,
              },
            });
            this.isload = false;
            this.$refs.complincmanual.reset();
          } else {
            this.isload = false;
            this.showAlertError(responseData.data.message);
          }
        } catch (error) {
          this.isload = false;
          console.log(error.response);
          this.showAlertError("Something went wrong please try again later.");
        }
      }
    },
    async uploadCustDocs(id, doc_type, doc) {
      let compressdata = await this.handleImageUpload(doc);
      let fileData = new FormData();
      fileData.append("document", compressdata);
      try {
        const response = await userService.uploadCustDocs(
          id,
          doc_type,
          fileData,
        );
        if (response.data.status_code === 200) {
          console.log("Logo Update");
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getcountryList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          this.dropdown.countryOptions = responseData.data.data.map((i) => {
            return { text: i.country_name, value: i.iso_alpha3 };
          });
          this.dropdown.nationalityList = responseData.data.data.map((i) => {
            return { text: i.nationality, value: i.iso_alpha3 };
          });
          if (this.customerINDdata.country_code) {
            await this.getStates();
          }
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
        this.CountryList = [];
      }
    },
    async getStates() {
      console.log(this.customerINDdata.country_code);

      try {
        const responseData = await commonService.getStatesList(
          this.customerINDdata.country_code,
        );
        if (responseData.data.status_code === 200) {
          this.dropdown.state_options = responseData.data.data.map((i) => {
            return {
              text: i.name,
              value: i.state_code,
            };
          });
        }

        console.log("States", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getCities(resetSelection = false) {
      if (resetSelection) this.customerINDdata.city_code = "";
      this.cityInputEnabled = false;
      this.dropdown.city_options = [];
      console.log(this.customerINDdata.state_code);

      console.log("state", this.customerINDdata.state_code);
      try {
        const responseData = await commonService.getCitiesList(
          this.customerINDdata.country_code,
          this.customerINDdata.state_code,
        );
        if (responseData.data.status_code === 200) {
          this.dropdown.city_options = responseData.data.data.map((i) => {
            return {
              text: i.name,
              value: i.id,
            };
          });
          this.cityInputEnabled = this.dropdown.city_options.length === 0;
          if (this.cityInputEnabled && this.customerINDdata.city?.name) {
            this.customerINDdata.city_code = this.customerINDdata.city.name;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getSourceOfFunds() {
      try {
        const responseData = await commonService.getparameterdropdowns("SOF");
        if (responseData.data.status_code === 200) {
          this.dropdown.sourceofFunds_list = responseData.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getparameterdropdowns(code) {
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          this.dropdown.ID_types = responseData.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
          if (this.isMykad) {
            this.customerINDdata.id_issue_date = null;
            this.customerINDdata.id_expire_date = null;
          }
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getzipcodes() {
      try {
        const responseData = await commonService.getZipCodes();
        if (responseData.data.status_code === 200) {
          this.dropdown.zipcodes = responseData.data.data;
        }

        console.log("zipcodes", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getOccupation() {
      try {
        const responseData = await commonService.getparameterdropdowns("OCC");
        if (responseData.data.status_code === 200) {
          this.dropdown.occupation_list = responseData.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
        }

        console.log("occupation", responseData);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>
<style lang="css">
.required:after {
  content: " *";
  color: red;
}
</style>
